export const DATE_FORMAT = 'dd MMM yyyy';
export const DATE_TIME_FORMAT = 'MMMM d, yyyy h:mm aa';

export const DEFAULT_FORMAT = {
  datePicker: DATE_FORMAT,
  monthPicker: 'MMM yyyy',
  quarterPicker: 'qqq yyyy',
  yearPicker: 'yyyy',
};
